import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LandingPage from "../pages/home/page";
import CadastroPage from "../pages/cadastro/page";
import DashboardPage from "../pages/dashboard/page";
import ContasPage from "../pages/contas/page";
import LancamentosPage from "../pages/lancamentos/page";
import CartoesPage from "../pages/cartoes/page";
import MetasPage from "../pages/metas/page";
import PerfilPage from "../pages/perfil/page";
import { AppLayout } from "../components/feature/AppLayout";
import { ProtectedRoute } from "../components/feature/ProtectedRoute";
import { AdminProtectedRoute } from "../components/feature/AdminProtectedRoute";
import { AdminLayout } from "../pages/admin/layout/AdminLayout";
import AdminDashboardPage from "../pages/admin/dashboard/page";
import AdminUsuariosPage from "../pages/admin/usuarios/page";
import AdminPlanosPage from "../pages/admin/planos/page";
import AdminAssinaturasPage from "../pages/admin/assinaturas/page";
import AdminPagamentosPage from "../pages/admin/pagamentos/page";
import AdminGatewaysPage from "../pages/admin/gateways/page";
import AdminConfiguracoesPage from "../pages/admin/configuracoes/page";
import AdminAuditoriaPage from "../pages/admin/auditoria/page";
import AdminWebhooksPage from "../pages/admin/webhooks/page";
import AdminIntegracoesPage from "../pages/admin/integracoes/page";
import AdminComunicadosPage from "../pages/admin/comunicados/page";
import ClientDetailPage from "../pages/admin/clientes/page";
import RelatoriosPage from '../pages/relatorios/page';
import InsightsPage from '../pages/insights/page';
import PagamentoRetornoPage from '../pages/pagamento/page';
import CalendarioPage from '../pages/calendario/page';
import FeedbackPage from '../pages/feedback/page';
import SugestoesPage from '../pages/sugestoes/page';
import AdminFeedbacksPage from '../pages/admin/feedbacks/page';
import AdminSugestoesPage from '../pages/admin/sugestoes/page';
import AdminAdministradoresPage from '../pages/admin/administradores/page';
import AdminAdministradorDetail from '../pages/admin/administradores/detail';
import NotificacoesPage from '../pages/notificacoes/page';
import AdminExecutivePage from '../pages/admin/visao-executiva/page';
import AccountStatementPage from '../pages/contas/extrato/page';
import FavorecidosPage from '../pages/favorecidos/page';
import AdminPandaAIPage from '../pages/admin/panda-ai/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/cadastro",
    element: <CadastroPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: "/dashboard", element: <DashboardPage /> },
          { path: "/contas", element: <ContasPage /> },
          { path: "/contas/extrato/:id", element: <AccountStatementPage /> },
          { path: "/favorecidos", element: <FavorecidosPage /> },
          { path: "/lancamentos", element: <LancamentosPage /> },
          { path: "/cartoes", element: <CartoesPage /> },
          { path: "/metas", element: <MetasPage /> },
          { path: "/calendario", element: <CalendarioPage /> },
          { path: "/relatorios", element: <RelatoriosPage /> },
          { path: "/insights", element: <InsightsPage /> },
          { path: "/perfil", element: <PerfilPage /> },
          { path: "/notificacoes", element: <NotificacoesPage /> },
          { path: "/feedback", element: <FeedbackPage /> },
          { path: "/sugestoes", element: <SugestoesPage /> },
        ],
      },
      { path: "/pagamento/retorno", element: <PagamentoRetornoPage /> },
    ],
  },
  {
    element: <AdminProtectedRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { path: "/admin", element: <AdminDashboardPage /> },
          { path: "/admin/usuarios", element: <AdminUsuariosPage /> },
          { path: "/admin/planos", element: <AdminPlanosPage /> },
          { path: "/admin/assinaturas", element: <AdminAssinaturasPage /> },
          { path: "/admin/pagamentos", element: <AdminPagamentosPage /> },
          { path: "/admin/gateways", element: <AdminGatewaysPage /> },
          { path: "/admin/configuracoes", element: <AdminConfiguracoesPage /> },
          { path: "/admin/auditoria", element: <AdminAuditoriaPage /> },
          { path: "/admin/webhooks", element: <AdminWebhooksPage /> },
          { path: "/admin/integracoes", element: <AdminIntegracoesPage /> },
          { path: "/admin/comunicados", element: <AdminComunicadosPage /> },
          { path: "/admin/clientes/:id", element: <ClientDetailPage /> },
          { path: "/admin/feedbacks", element: <AdminFeedbacksPage /> },
          { path: "/admin/sugestoes", element: <AdminSugestoesPage /> },
          { path: "/admin/administradores", element: <AdminAdministradoresPage /> },
          { path: "/admin/administradores/:id", element: <AdminAdministradorDetail /> },
          { path: "/admin/visao-executiva", element: <AdminExecutivePage /> },
          { path: "/admin/panda-ai", element: <AdminPandaAIPage /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
